export enum RoleTypeEnum {
  ADMIN = 'A',
  OPERATION = 'O',
  COOPERATIVE = 'C',
  USER = 'U'
}

const RoleTypeEnumLabels = {
  [RoleTypeEnum.ADMIN]: 'ADMIN',
  [RoleTypeEnum.OPERATION]: 'Vận hành (cho ĐVQL)'
};

export const RoleTypeSelectItem = [
  {id: RoleTypeEnum.ADMIN, itemName: RoleTypeEnumLabels[RoleTypeEnum.ADMIN]},
  {id: RoleTypeEnum.OPERATION, itemName: RoleTypeEnumLabels[RoleTypeEnum.OPERATION]}
]
